// extracted by mini-css-extract-plugin
export default {"nav-logo":"Experience_nav-logo__P0uij","btn":"Experience_btn__bh1E8","section":"Experience_section__nIz5I"};